import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

/** Accordion without transition animations, per spec. */
export default function FaqList() {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);
  const items = [1, 2, 3, 4, 5].map((n) => ({
    q: t(`faq.q${n}`),
    a: t(`faq.a${n}`),
  }));

  return (
    <div className="divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
      {items.map((it, idx) => {
        const expanded = open === idx;
        return (
          <div key={idx} data-testid={`faq-item-${idx}`}>
            <button
              type="button"
              onClick={() => setOpen(expanded ? -1 : idx)}
              data-testid={`faq-toggle-${idx}`}
              aria-expanded={expanded}
              className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left"
            >
              <span className="text-base sm:text-lg font-semibold text-slate-900">
                {it.q}
              </span>
              <span
                aria-hidden
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-700"
              >
                {expanded ? <Minus size={16} /> : <Plus size={16} />}
              </span>
            </button>
            {expanded && (
              <div className="px-6 pb-6 text-sm sm:text-base text-slate-600 leading-relaxed">
                {it.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
